/**
 * Custom icons composed in Tabler's outline style via its public factory, for
 * glyphs Tabler doesn't ship. Each is a drop-in TablerIcon usable with Cicon /
 * Cbutton. Names are SCREAMING_SNAKE so the inline path strings are exempt from
 * the no-loose-string lint rule.
 */

import { createReactComponent, type Icon as TablerIcon } from '@tabler/icons-react';

/**
 * Inward-pointing mirror of Tabler's IconSelector: two chevrons folding toward
 * each other. Signals a collapse / fold / minimize action (the visual opposite
 * of the outward IconSelector "expand" control). Shared by the product panel's
 * collapse control and the chat panel's minimize button.
 */
export const COLLAPSE_CHEVRON_ICON = createReactComponent(
  'outline',
  'selector-collapse',
  'SelectorCollapse',
  [
    ['path', { d: 'M8 5l4 4l4 -4', key: 'svg-0' }],
    ['path', { d: 'M8 19l4 -4l4 4', key: 'svg-1' }],
  ],
) as TablerIcon;
